// GlobalErrorBoundary.jsx
import React from "react"
import ErrorScreen from "../Screens/errorScreen"

class GlobalErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			hasError: false,
			error: null,
			errorInfo: null,
			errorCount: 0, // Contador de tentativas
			lastErrorTimestamp: null,
		}
	}

	static getDerivedStateFromError(error) {
		return { hasError: true }
	}

	componentDidCatch(error, errorInfo) {
		const errorKey = `${error.message}-${errorInfo?.componentStack}`;
		const isDuplicate = this.lastError === errorKey;
	  
		if (!isDuplicate) {
		  this.setState((prevState) => ({
			error,
			errorInfo,
			errorCount: prevState.errorCount + 1,
			lastErrorTimestamp: new Date().toISOString(),
		  }));
	  
		  this.logErrorToService(error, errorInfo);
		}
	  
		this.lastError = errorKey;
	  }
	  

	logErrorToService(error, errorInfo) {
		// Implementação do serviço de logging
		// Exemplo com Sentry:
		// if (typeof Sentry !== 'undefined') {
		//   Sentry.withScope((scope) => {
		//     scope.setExtras(errorInfo);
		//     Sentry.captureException(error);
		//   });
		// }
	}

	handleRetry = () => {
        this.state.errorCount++; //
        // Se houver muitas tentativas em um curto período, força um refresh completo
        if (this.state.errorCount >= 4) {
            // Volta uma página no histórico do navegador
             
			 window.location.href = '/home'
			 return
            
            
        }

        // Limpa o estado de erro e tenta novamente
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null,
        });
    }

	formatErrorForDisplay() {
		const { error, errorInfo, errorCount } = this.state

		// Formata as informações do erro para exibição
		return JSON.stringify(
			{
				message: error?.message || "Erro desconhecido",
				componentStack: errorInfo?.componentStack,
				errorCount,
			},
			null,
			2
		)
	}

	render() {
		if (this.state.hasError) {
			// Prepara informações adicionais para o ErrorScreen
			const errorInfo = this.formatErrorForDisplay()

			return (
				<ErrorScreen errorInfo={errorInfo} onRetry={this.handleRetry} />
			)
		}

		return this.props.children
	}
}
export default GlobalErrorBoundary
